// extracted by mini-css-extract-plugin
module.exports = {"theme":"blueprints-module--theme--3NGBv","vertical":"blueprints-module--vertical--10Rt_"};